import { SocialAccount } from "types/influencer"

export interface User {
    email: string,
    name: string,
    uuid: string,
    role: Role
    brands: Brand[],
    notification_preferences: string[]
}

interface Role {
    name: string,
    slug: string
}

interface Brand {
    id: number,
    name: string
}

export interface UserListPayload {
    page: number,
    limit?: number,
    force?: boolean
}

export interface UserListResponse {
    count: number,
    items: User[],
}

export interface UserListSlice extends UserListResponse {
    loading: boolean,
    page: number,
    last_fetched_at: number | null,
    has_more: boolean,
    expired: boolean,
    error: string | null
}

export interface UserDataSlice {
    users: Record<string, { user: User, last_fetched_at: number }>
    error: string | null,
    loading: boolean
}

export interface NewUser {
    name: string,
    email: string,
    role: string,
    brands: number[],
}

export interface UserBrand {
    id: number,
    name: string,
    social_account?: SocialAccount | null
    strategy_available?: boolean
}

export interface UserRole {
    name: string,
    slug: string,
    privileges?: Privilege[]
}

export interface Privilege {
    slug: string,
    object: {
        name: string
    },
    type: {
        name: string
    },
    group: {
        name: string
    }
}

export const OWNER_ROLE_SLUG = 'owner';
